// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchButton_button__3BZdm MenuButton_button__2nOpO","icon":"SearchButton_icon__2VHVf"};